import * as angular from 'angular';
import * as _ from "lodash";
import {IController} from 'angular';

export class BringozCustomSelectListComponent implements IController {


  value: any;
  options?: any;
  optionsWrapper?: { list?: any[], propertyRef: string, skills?: string[]};
  optionsPrefix: string;
  ngPlaceholder: any;
  excludeIds: string[];
  selectedIds: string[];
  onChange: Function;

  public queryString: string;
  public list: { name: string, id: string, extraText?: string }[];
  public excludedMap: any;
  public selectedMap: any;

  constructor() {
  }

  $onInit() {
    this.list = this.optionsWrapper ?
      _.map(this.optionsWrapper.list, (o) => {
        return {name: _.get(o, this.optionsWrapper.propertyRef), id: o.id, isRequired: o.isRequired, skills: _.get(o, this.optionsWrapper.skills)}
      }) :
      _.map(this.options, (o) => {
        return {name: o, id: o}
      });
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }

    if (changes.selectedIds) {
      this.selectedMap = {};
      _.forEach(this.selectedIds, (id) => {
        this.selectedMap[id] = true;
      })
    }

  }

  submitQuery(query) {
    this.queryString = query;
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozCustomSelectList', {
    bindings: {
      value: '<',
      options: '<',
      optionsWrapper: '<?',
      excludeIds: '<?',
      selectedIds: '<?',
      optionsPrefix: '@?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./bringoz-custom-select-list.html').default,
    controller: BringozCustomSelectListComponent
  });
